module.exports = __webpack_public_path__ + "media/components/images/panels/1-a-0fc604d07e10ec4eb45a74b872b646c5.jpeg";